import { types } from 'mobx-state-tree';


const PLUMBING_TYPES = {
    COPPER: 'copper',
    GALVANIZED: 'galvanized',
    IRON: 'iron',
    PVC: 'pvc',
    ABS: 'abs',
    PEX: 'pex',
    UNKNOWN: 'unknown',
};

const PlumbingTypeEnum = types.enumeration('PlumbingType', Object.values(PLUMBING_TYPES));

export {
    PlumbingTypeEnum,
};
export default PLUMBING_TYPES;
